import React from 'react';
export function FinalCTA() {
  return <section className="bg-[#0d4a45] py-16 md:py-24 relative overflow-hidden" data-id="element-165">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-80 h-80 rounded-full bg-[#e8a0a0]/15 translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-166" />
      <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-[#c9a84c]/15 -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-167" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-white/3 pointer-events-none" data-id="element-168" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 text-center" data-id="element-169">
        <span className="font-dm text-xs font-bold tracking-widest text-[#e8a0a0] uppercase" data-id="element-170">
          Es tu momento
        </span>
        <h2 className="font-playfair text-3xl md:text-5xl font-bold text-white mt-4 mb-5 leading-tight" data-id="element-171">
          Tu dinero propio está a <span className="text-[#e8c97a]" data-id="element-172">$6.36</span>{' '}
          de distancia
        </h2>
        <p className="font-dm text-white/75 text-lg md:text-xl leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-173">
          Deja de pagar el precio de no tener dinero propio.
        </p>
        <p className="font-playfair italic text-[#e8a0a0] text-xl mb-10" data-id="element-174">
          "Hoy es el día."
        </p>

        <a href="#oferta" className="inline-block bg-[#c9a84c] hover:bg-[#e8c97a] text-[#0d4a45] font-dm font-bold text-lg px-10 py-5 rounded-full transition-all shadow-2xl hover:shadow-[#c9a84c]/30 hover:scale-105 active:scale-95" data-id="element-175">
          🚀 Empezar ahora por $6.36 →
        </a>

        <div className="mt-6 flex flex-wrap justify-center gap-4 text-white/50 text-sm font-dm" data-id="element-176">
          <span data-id="element-177">⚡ Acceso inmediato</span>
          <span data-id="element-178">🔒 Pago seguro</span>
        </div>

        {/* Final emotional line */}
        <div className="mt-12 pt-8 border-t border-white/10" data-id="element-179">
          <p className="font-dm text-white/50 text-sm max-w-md mx-auto" data-id="element-180">
            "Recupera tu identidad profesional sin sacrificar la hora de la
            cena."
          </p>
        </div>
      </div>
    </section>;
}